// extracted by mini-css-extract-plugin
export default {"ctn":"bag_ctn__NcNLA","textBox":"bag_textBox__zDXwE","video":"bag_video__OowNi"};